import { v4 as uuidv4 } from "uuid";
import Message from "../models/message.ts";
import axios from "axios";
import "../styles/style.css";
import { LoadScreen2 } from "./LoadScreen";

let interval;
export function Page({ itemInfo, type }) {
  let item = <></>;

  switch (type) {
    case "skills":
      item = <Skills itemInfo={itemInfo} />;
      break;

    case "chatbox":
      item = <ChatBox itemInfo={itemInfo} />;
      break;
    default:
      break;
  }
  return item;
}

function ChatBox({ itemInfo }) {
  const socket = itemInfo.socket;
  return (
    <>
      <div className="chat closed">
        <div className="chat-header">
          <img
            alt="logo"
            className="chat-logo"
            src="https://amantes30.github.io/icons/SVG/logo(new).svg"
          ></img>

          <button className="chat-close" onClick={toggleChat}>
            <img src="/close.svg" />
          </button>
        </div>
        <div className="chat-body">
          <ul id="messages">
            <li></li>
          </ul>

          <form
            id="chat-form"
            style={{ display: "none" }}
            onSubmit={(e) => {
              e.preventDefault();
              if (!socket.connected) {
                alert("Please input your email first");
                return;
              }
              const msg = {
                message: e.target.message.value,
                sender: window.localStorage.getItem("email"),
                timeStamp: new Date().toISOString(),
                roomId: window.localStorage.getItem("roomID"),
              };
              console.log("yes");
              socket.emit("message", new Message(msg));
            }}
          >
            {itemInfo.site === "en" ? (
              <>
                <input
                  type="text"
                  placeholder="say what?"
                  className="form-control"
                  name="message"
                  autoComplete="off"
                />

                <button type="submit" id="send-btn">
                  Send
                </button>
              </>
            ) : (
              <>
                <input
                  type="text"
                  placeholder="说什么？"
                  className="form-control"
                  name="message"
                  autoComplete="off"
                />
                <button type="submit" id="send-btn">
                  发送
                </button>
              </>
            )}
          </form>

          <form
            id="hidden-chat-form"
            onSubmit={async (e) => {
              e.preventDefault();

              const input = document.getElementById("email-input");
              input.classList.toggle("loading");
              input.readOnly = true;
              let message = "Connecting chat server";
              LoadScreen2(message, true);

              window.localStorage.setItem("email", e.target.email.value);

              axios
                .get(
                  `${process.env.REACT_APP_API_URL}/login?email=${e.target.email.value}`,
                )
                .then((res) => {
                  console.log(res.data);
                  if (socket.connected) {
                    // welcome message
                    const messages = document.getElementById("messages");
                    const li = document.createElement("li");
                    const p = document.createElement("p");
                    socket.emit("setuser", res.data);
                    messages.innerHTML = "";
                    writeAnim(
                      `Welcome to the chat. Please give me a few seconds to connect to the server.\n Feel free to put in your inquiry, I can read it when I'm online.`,
                      p,
                      5,
                    );

                    //p.textContent = `Welcome to the chat. Please give me a few seconds to connect to the server.\n Feel free to put in your inquiry, I can read it when I'm online.`;
                    li.className = "msg";
                    li.appendChild(p);
                    messages.appendChild(li);
                    e.target.reset();
                    e.target.style = "display:none";
                    document.getElementById("chat-form").style =
                      "display: flex";

                    LoadScreen2(message, false);
                  } else {
                    alert(
                      "Server is down, This feature is not available at the moment",
                    );
                  }
                })
                .catch((err) => {
                  alert("Error connecting to the server");
                });
            }}
          >
            {itemInfo.site === "en" ? (
              <input
                type="email"
                placeholder="Your Email"
                className="form-control"
                name="email"
                autoComplete="off"
                required
                id="email-input"
              />
            ) : (
              <input
                type="email"
                placeholder="电子邮件"
                className="form-control"
                name="email"
                autoComplete="off"
                required
                id="email-input"
              />
            )}

            <button type="submit" id="send-btn">
              set
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
function Skills({ itemInfo }) {
  var list = [];
  var list2 = [];
  var list3 = [];
  itemInfo.user.skills.forEach((skill) => {
    switch (skill.type) {
      case "lang":
        list.push(
          <li key={uuidv4()} className={skill.text + "logo"}>
            <a href={skill.link} key={uuidv4()}>
              <img
                className="skill-icon w100 shadowed"
                src={skill.icon}
                alt={skill.text}
              ></img>
            </a>
          </li>,
        );
        break;
      case "framework":
        list2.push(
          <li key={uuidv4()} className={skill.text + "logo"}>
            <a href={skill.link} key={uuidv4()}>
              <img
                className="skill-icon w100 shadowed"
                src={skill.icon}
                alt={skill.text}
              ></img>
            </a>
          </li>,
        );
        break;
      case "tool":
        list3.push(
          <li key={uuidv4()} className={skill.text + "logo"}>
            <a href={skill.link} key={uuidv4()}>
              <img
                className="skill-icon w100 shadowed"
                src={skill.icon}
                alt={skill.text}
              ></img>
            </a>
          </li>,
        );
        break;
      default:
        break;
    }
  });
  return (
    <div
      className="page df skills"
      style={{ animationTimeline: "view(70% 10%)" }}
    >
      <div
        className="skills-animoji"
        style={{ animationTimeline: "view(70% 20%)" }}
      >
        <img className="w100" src="/image/animoji.png"></img>
      </div>

      <section className="skill-wrapper df">
        {itemInfo.site === "en" ? (
          <h2 className="g-c-text">Programming languages</h2>
        ) : (
          <h2 className="g-c-text">编程语言</h2>
        )}

        <ul className="skill-item-list df scroll-anim">
          {list}
          {list}
        </ul>
      </section>

      <section className="skill-wrapper df">
        <h2 className="g-c-text">Frameworks</h2>
        <ul className="skill-item-list df">{list2}</ul>
      </section>

      <section className="skill-wrapper df">
        {itemInfo.site === "en" ? (
          <h2 className="g-c-text">Tools</h2>
        ) : (
          <h2 className="g-c-text">工具</h2>
        )}

        <ul className="skill-item-list df scroll-anim">
          {list3}
          {list3}
        </ul>
      </section>

      {/* <p>3D modelling (3ds Max)</p> */}
    </div>
  );
}

export function toggleChat(e) {
  e.preventDefault();
  const chat = document.querySelector(".chat");
  const chatboxToggle = document.querySelector(".chatbox-toggle");
  const messages = document.getElementById("messages");
  const inputField = document.getElementById("email-input");
  if (chat.classList.contains("closed")) {
    chatboxToggle.style = "display:none";
    chat.classList.toggle("closed", false);
    messages.scrollTop = messages.scrollHeight;
    inputField.focus();

    const p = document.createElement("p");

    const li = document.createElement("li");

    // writeAnim(
    //   'Please enter your email address, then I can try to connect with you',
    //   p,
    //   10
    // )
    li.className = "msg";
    li.appendChild(p);
    messages.appendChild(li);
  } else {
    chat.classList.toggle("closed", true);
    chatboxToggle.style = "display:flex, text-align:center";
  }
}

export function writeAnim(text, element, time) {
  clearInterval(interval);
  const text_to_list = text.split("");
  let counter = 0;
  let inp = [];
  interval = setInterval(() => {
    if (counter < text_to_list.length) {
      inp.push(text_to_list[counter]);
      element.innerText = inp.join("");
      counter++;
    } else {
      clearInterval(interval);
    }
  }, time);
}
